import {Component, HostListener, Input, OnInit, ViewChild} from '@angular/core';
import {TotalesCFEDTO} from '../../../models/dtos/TotalesCFEDTO';
import {DetalleCFEDTO} from '../../../models/dtos/DetalleCFEDTO';
import {IdentificacionCFEDTO} from '../../../models/dtos/IdentificacionCFEDTO';
import {EmisorCFEDTO} from '../../../models/dtos/EmisorCFEDTO';
import {ReceptorCFEDTO} from '../../../models/dtos/ReceptorCFEDTO';
import {CFEDTO} from '../../../models/dtos/CFEDTO';
import {RespuestaEmisionCFEDTO} from '../../../models/dtos/RespuestaEmisionCFEDTO';
import {EmisionCfeService} from '../../services/emision-cfe.service';
import {IdentificacionComponent} from '../../components/identificacion/identificacion.component';
import {EmisorComponent} from '../../components/emisor/emisor.component';
import {ReceptorComponent} from '../../components/receptor/receptor.component';
import {TotalesComponent} from '../../components/totales/totales.component';
import {DetallesComponent} from '../../components/detalles/detalles.component';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialog} from '@angular/material';
import {ProgressOverlayService} from '../../services/progress-overlay.service';
import {ProgressSpinnerOverlayRef} from '../../utils/progress-spinner/progress-spinner-overlay-ref';
import {KeycloakService} from 'keycloak-angular';
import {ConfiguracionInicialDTO} from '../../../models/dtos/ConfiguracionInicialDTO';
import {AdendaComponent} from '../../components/adenda/adenda.component';
import {
  ERROR_COMBINACION_TIPO_CFE_Y_TIPO_DOCUMENTO_RECEPTOR_INVALIDO,
  ERROR_DEL_SWITCH_AL_EMITIR_CFE, ERROR_FALTAN_DATOS_EN_DETALLES_CFE,
  ERROR_GENERAL_AL_EMITIR_CFE, NO_COINCIDE_RECEPTOR_EN_NOTA_DE_CREDITO,
  NO_EXISTE_REFERENCIA_EN_NOTA_DE_CREDITO
} from '../../../constants/EmisionCfeErrorCodes';
import {MensajeUtils} from '../../utils/mensajes/mensaje-utils';
import {ActivatedRoute} from '@angular/router';
import {DatosInicioIdentificacionDTO} from '../../../models/dtos/datosInicio/DatosInicioIdentificacionDTO';
import {DatosInicioTotalesDTO} from '../../../models/dtos/datosInicio/DatosInicioTotalesDTO';
import {DatosInicioReceptorDTO} from '../../../models/dtos/datosInicio/DatosInicioReceptorDTO';
import {AdendaDTO} from '../../../models/dtos/AdendaDTO';
import {DatosInicioEmisionCFEDTO} from '../../../models/dtos/datosInicio/DatosInicioEmisionCFEDTO';
import {
  COD_TIPO_CFE_E_FACTURA, COD_TIPO_CFE_E_FACTURA_EXP, COD_TIPO_CFE_E_RESGUARDO,
  COD_TIPO_CFE_E_TICKET,
  COD_TIPO_CFE_NOTA_CREDITO_E_FACTURA, COD_TIPO_CFE_NOTA_CREDITO_E_FACTURA_EXP,
  COD_TIPO_CFE_NOTA_CREDITO_E_TICKET,
  COD_TIPO_CFE_NOTA_DEBITO_E_FACTURA, COD_TIPO_CFE_NOTA_DEBITO_E_FACTURA_EXP,
  COD_TIPO_CFE_NOTA_DEBITO_E_TICKET
} from '../../../constants/ConstantesTipoCFE';
import {ReferenciasCFEDTO} from '../../../models/dtos/ReferenciasCFEDTO';
import {ReferenciasComponent} from '../../components/referencias/referencias.component';
import {ReferenciaCFEDTO} from '../../../models/dtos/ReferenciaCFEDTO';
import {TipoCFEDTO} from '../../../models/dtos/TipoCFEDTO';
import {DatosInicioReferenciasDTO} from '../../../models/dtos/datosInicio/DatosInicioReferenciasDTO';
import {Utils} from '../../utils/utils';
import {TipoMonedaDTO} from '../../../models/dtos/TipoMonedaDTO';
import {DatosInicioDetallesDTO} from '../../../models/dtos/datosInicio/DatosInicioDetallesDTO';
import {CREDITOS_FISCALES_COD_RET_PREFIX} from '../../../constants/ConstantesCFE';

@Component
({
  selector: 'app-emision-cfe',
  templateUrl: './emision-cfe.component.html',
  styleUrls: ['./emision-cfe.component.scss']
})
export class EmisionCfeComponent implements OnInit
{
  // Modelo de la componente de identificación.
  identificacionCFEDTO: IdentificacionCFEDTO = null;

  // Modelo de la componente del emisor.
  emisorCFEDTO: EmisorCFEDTO = null;

  // Modelo de la componente del receptor.
  receptorCFEDTO: ReceptorCFEDTO = null;

  // Modelo de la componente de los detalles.
  detallesCFEsDTOs: Array<DetalleCFEDTO> = null;

  // Modelo de la componente de los totales.
  totalesCFEDTO: TotalesCFEDTO = null;

  // Modelo de la componente de la adenda.
  adendaDTO: AdendaDTO;

  // Modelo de la componente de referencias.
  referenciasCFEDTO: ReferenciasCFEDTO;

  mostrarReferencias: boolean;

  emisionCfeService: EmisionCfeService;

  esEResguardo: boolean = false;

  codigoCFESeleccionado = null;

  @ViewChild(IdentificacionComponent, {static: false})
  private identificacionComponent: IdentificacionComponent;

  @ViewChild(EmisorComponent, {static: false})
  private emisorComponent: EmisorComponent;

  @ViewChild(ReceptorComponent, {static: false})
  private receptorComponent: ReceptorComponent;

  @ViewChild(TotalesComponent, {static: false})
  private totalesComponent: TotalesComponent;

  @ViewChild(DetallesComponent, {static: false})
  private detallesComponent: DetallesComponent;

  @ViewChild(AdendaComponent, {static: false})
  private adendaComponent: AdendaComponent;

  @ViewChild(ReferenciasComponent, {static: false})
  private referenciasComponent: ReferenciasComponent;

  private progressSpinnerOverlayRef: ProgressSpinnerOverlayRef;

  formGroup: FormGroup = null;

  // Datos iniciales (valores de combos, etc) para la componente de identificación.
  datosInicioIdentificacionDTO: DatosInicioIdentificacionDTO = null;

  // Datos iniciales (valores de combos, etc) para la componente del receptor.
  datosInicioReceptorDTO: DatosInicioReceptorDTO = null;

  // Datos iniciales (valores de combos, etc) para la componente de detalles.
  datosInicioDetallesDTO: DatosInicioDetallesDTO = null;

  // Datos iniciales (valores de combos, etc) para la componente de totales.
  datosInicioTotalesDTO: DatosInicioTotalesDTO = null;

  // Datos iniciales (valores de combos, etc) para la componente de referencias.
  datosInicioReferenciasDTO: DatosInicioReferenciasDTO = null;

  private mensajeUtils: MensajeUtils;

  constructor(emisionCfeService: EmisionCfeService, private matDialog: MatDialog,
              private progressOverlayService: ProgressOverlayService, private keycloakService: KeycloakService,
              private route: ActivatedRoute)
  {
    this.mostrarReferencias = false;
    this.emisionCfeService = emisionCfeService;
    this.mensajeUtils = new MensajeUtils(this.matDialog);

    this.limpiar = this.limpiar.bind(this);
  }

  ngOnInit()
  {
    this.inicializarDatos();
  }

  private inicializarDatos() {
    const datosInicioEmisionCFEDTO: DatosInicioEmisionCFEDTO = this.route.snapshot.data.configuracion;
    this.inicializarDatosIniciosComponentes(datosInicioEmisionCFEDTO);
    this.inicializarDatosModelosComponentes(datosInicioEmisionCFEDTO);

    // Aquí se crea el form group y los respectivos validators que esta page necesita.
    this.construirFormGroup();
    this.setearTotalesConditionalValidators();
    this.setearTipoReferenciaConditionalValidators();
    this.setearReferenciasConditionalValidators();
  }

  private inicializarDatosModelosComponentes(datosInicioEmisionCFEDTO: DatosInicioEmisionCFEDTO): void
  {
    this.identificacionCFEDTO = new IdentificacionCFEDTO();
    if (this.emisionCfeService.getEmisorCFEDTO()) {
      this.emisorCFEDTO = Object.assign(new EmisorCFEDTO(), this.emisionCfeService.getEmisorCFEDTO());
    } else {
      this.emisorCFEDTO = JSON.parse(localStorage.getItem("EMISOR"));
    }
    this.receptorCFEDTO = new ReceptorCFEDTO();

    this.detallesCFEsDTOs = new Array<DetalleCFEDTO>();

    this.totalesCFEDTO = new TotalesCFEDTO();
    this.totalesCFEDTO.tipoMoneda = this.obtenerTipoMoneda('UYU');
    this.totalesCFEDTO.tipoCambio = 1;

    this.adendaDTO = new AdendaDTO();

    this.referenciasCFEDTO = new ReferenciasCFEDTO();
    this.referenciasCFEDTO.tipoReferencia = 'REF_ESPECIFICA';
    this.referenciasCFEDTO.referenciaCFE = new ReferenciaCFEDTO();
  }

  private inicializarDatosIniciosComponentes(datosInicioEmisionCFEDTO: DatosInicioEmisionCFEDTO): void
  {
    const configuracionInicialDTO: ConfiguracionInicialDTO = datosInicioEmisionCFEDTO.configuracionInicialDTO;

    this.datosInicioIdentificacionDTO = new DatosInicioIdentificacionDTO();
    this.datosInicioIdentificacionDTO.tiposCFEsDTOs = configuracionInicialDTO.tiposCFEsDTOs;
    this.datosInicioIdentificacionDTO.formasPagosDTOs = configuracionInicialDTO.formasPagosDTOs;
    this.datosInicioIdentificacionDTO.clausulaVentaDTOs = configuracionInicialDTO.clausulaVentaDTOs;
    this.datosInicioIdentificacionDTO.modalidadVentaDTOs = configuracionInicialDTO.modalidadVentaDTOs;
    this.datosInicioIdentificacionDTO.viaTransportacionDTOs = configuracionInicialDTO.viaTransportacionDTOs;

    this.datosInicioReceptorDTO = new DatosInicioReceptorDTO();
    this.datosInicioReceptorDTO.tiposDocumentosDTOs = configuracionInicialDTO.tiposDocumentosDTOs;
    this.datosInicioReceptorDTO.paisesDTOs = configuracionInicialDTO.paisesDTOs;
    this.datosInicioReceptorDTO.receptoresCFEsDisponiblesDTOs = datosInicioEmisionCFEDTO.receptoresCFEDTOs;
    this.datosInicioReceptorDTO.esABM = false;

    this.datosInicioDetallesDTO = new DatosInicioDetallesDTO();
    this.datosInicioDetallesDTO.esModoEResguardo = false;
    this.datosInicioDetallesDTO.indiceDetalleCFESeleccionado = null;
    this.datosInicioDetallesDTO.columnasMostradas = ['descripcion', 'cantidad', 'precioUnitario', 'precioVenta', 'impuesto', 'montoIVA', 'montoTotal', 'modificar', 'eliminar'];
    this.datosInicioDetallesDTO.impuestosDTOs = configuracionInicialDTO.impuestosDTOs;
    this.datosInicioDetallesDTO.tiposRetencionesDTOs = configuracionInicialDTO.tiposRetencionesDTOs;
    this.datosInicioDetallesDTO.tiposCFEsDTOs = configuracionInicialDTO.tiposCFEsDTOs;
    this.datosInicioDetallesDTO.sePuedeAgregarDetalleCFE = false;
    this.datosInicioDetallesDTO.tiposCodigosDTOs = configuracionInicialDTO.tiposCodigosDTOs;
    this.datosInicioDetallesDTO.tiposPesoDTOs = configuracionInicialDTO.tiposPesosDTOs;

    this.datosInicioTotalesDTO = new DatosInicioTotalesDTO();
    this.datosInicioTotalesDTO.tiposMonedasDTOs = configuracionInicialDTO.tiposMonedasDTOs;
    this.datosInicioTotalesDTO.codigoTipoMonedaSeleccionado = 'UYU';
    this.datosInicioTotalesDTO.estaHabilitadoTipoCambio = false;

    this.datosInicioReferenciasDTO = new DatosInicioReferenciasDTO();
    this.datosInicioReferenciasDTO.tiposCFEsDTOs = configuracionInicialDTO.tiposCFEsDTOs;
    this.datosInicioReferenciasDTO.mostrarReferenciaEspecifica = true;
  }

  private construirFormGroup(): void
  {
    this.formGroup = new FormGroup({
      // Identificación validators.
      tipoCFEControl: new FormControl(this.identificacionCFEDTO.tipoCFE, [Validators.required]),
      serieControl: new FormControl(this.identificacionCFEDTO.serie, []),
      numeroControl: new FormControl(this.identificacionCFEDTO.numero, []),
      fechaEmisionControl: new FormControl(this.identificacionCFEDTO.fechaEmision, [Validators.required]),
      formaPagoControl: new FormControl(this.identificacionCFEDTO.formaPago, [Validators.required]),
      clausulaVentaControl: new FormControl(this.identificacionCFEDTO.clausulaVenta, []),
      modalidadVentaControl: new FormControl(this.identificacionCFEDTO.modalidadVenta, []),
      viaTransportacionControl: new FormControl(this.identificacionCFEDTO.viaTransportacion, []),
      // Emisor validators.
      rutEmisorControl: new FormControl(this.emisorCFEDTO.rut, [Validators.required]),
      razonSocialEmisorControl: new FormControl(this.emisorCFEDTO.razonSocial, [Validators.required]),
      domicilioFiscalEmisorControl: new FormControl(this.emisorCFEDTO.domicilioFiscal, [Validators.required]),
      ciudadEmisorControl: new FormControl(this.emisorCFEDTO.ciudad, [Validators.required]),
      departamentoEmisorControl: new FormControl(this.emisorCFEDTO.departamento, [Validators.required]),
      // Receptor validators.
      tipoDocumentoReceptorControl: new FormControl(this.receptorCFEDTO.tipoDocumento, [Validators.required]),
      paisReceptorControl: new FormControl(this.receptorCFEDTO.pais, [Validators.required]),
      documentoReceptorControl: new FormControl(this.receptorCFEDTO.documento, [Validators.required]),
      razonSocialReceptorControl: new FormControl(this.receptorCFEDTO.razonSocial, [Validators.required]),
      direccionReceptorControl: new FormControl(this.receptorCFEDTO.direccion, [Validators.required]),
      ciudadReceptorControl: new FormControl(this.receptorCFEDTO.ciudad, [Validators.required]),
      departamentoReceptorControl: new FormControl(this.receptorCFEDTO.departamento, [Validators.required]),
      identificadorCompraControl: new FormControl(this.receptorCFEDTO.identificadorCompra, []),
      // Totales validators.
      tipoMonedaControl: new FormControl(this.totalesCFEDTO.tipoMoneda, [Validators.required]),
      tipoCambioControl: new FormControl(this.totalesCFEDTO.tipoCambio, [Validators.required]),
      subtotalControl: new FormControl(this.totalesCFEDTO.subtotal, []),
      montoIVAControl: new FormControl(this.totalesCFEDTO.montoIVA, []),
      montoTotalControl: new FormControl(this.totalesCFEDTO.montoTotal, []),
      cantidadLineasDetallesControl: new FormControl(this.totalesCFEDTO.cantidadLineasDetalles, [Validators.required]),
      montoTotalRetenidoEResgControl: new FormControl(this.totalesCFEDTO.montoTotalRetenidoEResg, []),
      montoTotalCreditoFiscalEResgControl: new FormControl(this.totalesCFEDTO.montoTotalCreditoFiscalEResg, []),
      // Adenda validator.
      adendaControl: new FormControl(this.adendaDTO.texto),
      // Referencias validator.
      tipoReferenciaControl: new FormControl(this.referenciasCFEDTO.referenciaCFE.tipoCFE, []),
      tipoCFEReferenciaControl: new FormControl(this.referenciasCFEDTO.referenciaCFE.tipoCFE, []),
      serieReferenciaControl: new FormControl(this.referenciasCFEDTO.referenciaCFE.serie, []),
      numeroReferenciaControl: new FormControl(this.referenciasCFEDTO.referenciaCFE.numero, []),
      fechaEmisionReferenciaControl: new FormControl(this.referenciasCFEDTO.referenciaCFE.fechaEmision, []),
      razonReferenciaControl: new FormControl(this.referenciasCFEDTO.razonReferencia, [])
    });

    this.formGroup.get('direccionReceptorControl').disable();
    this.formGroup.get('ciudadReceptorControl').disable();
    this.formGroup.get('departamentoReceptorControl').disable();
  }

  private setearIdentificacionCFEConditionalValidators(codigoTipoCFE: number): void
  {
    const clausulaVentaControl: AbstractControl = this.formGroup.get('clausulaVentaControl');
    const modalidadVentaControl: AbstractControl = this.formGroup.get('modalidadVentaControl');
    const viaTransportacionControl: AbstractControl = this.formGroup.get('viaTransportacionControl');

        if (codigoTipoCFE === COD_TIPO_CFE_E_FACTURA_EXP || codigoTipoCFE === COD_TIPO_CFE_NOTA_CREDITO_E_FACTURA_EXP || codigoTipoCFE === COD_TIPO_CFE_NOTA_DEBITO_E_FACTURA_EXP)
        {
          clausulaVentaControl.setValidators([Validators.required]);
          modalidadVentaControl.setValidators([Validators.required]);
          viaTransportacionControl.setValidators([Validators.required]);
        }
        else
        {
          clausulaVentaControl.setValidators(null);
          modalidadVentaControl.setValidators(null);
          viaTransportacionControl.setValidators(null);
        }
  }

  private setearTotalesConditionalValidators(): void
  {
    const tipoCFEControl: AbstractControl = this.formGroup.get('tipoCFEControl');
    const subtotalControl: AbstractControl = this.formGroup.get('subtotalControl');
    const montoIVAControl: AbstractControl = this.formGroup.get('montoIVAControl');
    const montoTotalControl: AbstractControl = this.formGroup.get('montoTotalControl');
    const montoTotalRetenidoEResgControl: AbstractControl = this.formGroup.get('montoTotalRetenidoEResgControl');
    const montoTotalCreditoFiscalEResgControl: AbstractControl = this.formGroup.get('montoTotalCreditoFiscalEResgControl');

    tipoCFEControl.valueChanges.subscribe(codigoTipoCFE =>
    {
      if (Utils.isNotNullOrUndefined(codigoTipoCFE))
      {
        if (codigoTipoCFE === COD_TIPO_CFE_E_RESGUARDO)
        {
          subtotalControl.setValidators(null);
          montoIVAControl.setValidators(null);
          montoTotalControl.setValidators(null);
          montoTotalRetenidoEResgControl.setValidators([Validators.required]);
          montoTotalCreditoFiscalEResgControl.setValidators([Validators.required]);
        }
        else
        {
          subtotalControl.setValidators([Validators.required]);
          montoIVAControl.setValidators([Validators.required]);
          montoTotalControl.setValidators([Validators.required]);
          montoTotalRetenidoEResgControl.setValidators(null);
          montoTotalCreditoFiscalEResgControl.setValidators(null);
        }
      }
      else
      {
        subtotalControl.setValidators(null);
        montoIVAControl.setValidators(null);
        montoTotalControl.setValidators(null);
        montoTotalRetenidoEResgControl.setValidators(null);
        montoTotalCreditoFiscalEResgControl.setValidators(null);
      }

      subtotalControl.updateValueAndValidity();
      montoIVAControl.updateValueAndValidity();
      montoTotalControl.updateValueAndValidity();
      montoTotalRetenidoEResgControl.updateValueAndValidity();
      montoTotalCreditoFiscalEResgControl.updateValueAndValidity();
    });
  }

  private setearTipoReferenciaConditionalValidators(): void
  {
    const tipoCFEControl: AbstractControl = this.formGroup.get('tipoCFEControl');
    const tipoReferenciaControl: AbstractControl = this.formGroup.get('tipoReferenciaControl');

    tipoCFEControl.valueChanges.subscribe(codigoTipoCFE =>
    {
      if (Utils.isNotNullOrUndefined(codigoTipoCFE))
      {
        if (this.esNotaDeCreditoElCodigoTipoCFE(codigoTipoCFE) || this.esNotaDeDebitoElCodigoTipoCFE(codigoTipoCFE))
        {
          tipoReferenciaControl.setValidators([Validators.required]);
        }
        else
        {
          tipoReferenciaControl.setValidators(null);
        }
      }
      else
      {
        tipoReferenciaControl.setValidators(null);
      }

      tipoReferenciaControl.updateValueAndValidity();
    });
  }

  private setearReferenciasConditionalValidators(): void
  {
    const tipoReferenciaControl: AbstractControl = this.formGroup.get('tipoReferenciaControl');
    const tipoCFEReferenciaControl: AbstractControl = this.formGroup.get('tipoCFEReferenciaControl');
    const serieReferenciaControl: AbstractControl = this.formGroup.get('serieReferenciaControl');
    const numeroReferenciaControl: AbstractControl = this.formGroup.get('numeroReferenciaControl');
    const fechaEmisionReferenciaControl: AbstractControl = this.formGroup.get('fechaEmisionReferenciaControl');
    const razonReferenciaControl: AbstractControl = this.formGroup.get('razonReferenciaControl');

    tipoReferenciaControl.valueChanges.subscribe(tipoReferencia =>
    {
      if (tipoReferencia === 'REF_ESPECIFICA')
      {
        tipoCFEReferenciaControl.setValidators([Validators.required]);
        serieReferenciaControl.setValidators([Validators.required]);
        numeroReferenciaControl.setValidators([Validators.required]);
        fechaEmisionReferenciaControl.setValidators(null);
        razonReferenciaControl.setValidators(null);
      }
      else if (tipoReferencia === 'REF_GLOBAL')
      {
        tipoCFEReferenciaControl.setValidators(null);
        serieReferenciaControl.setValidators(null);
        numeroReferenciaControl.setValidators(null);
        fechaEmisionReferenciaControl.setValidators(null);
        razonReferenciaControl.setValidators([Validators.required]);
      }
      else
      {
        tipoCFEReferenciaControl.setValidators(null);
        serieReferenciaControl.setValidators(null);
        numeroReferenciaControl.setValidators(null);
        fechaEmisionReferenciaControl.setValidators(null);
        razonReferenciaControl.setValidators(null);
      }

      tipoCFEReferenciaControl.updateValueAndValidity();
      serieReferenciaControl.updateValueAndValidity();
      numeroReferenciaControl.updateValueAndValidity();
      fechaEmisionReferenciaControl.updateValueAndValidity();
      razonReferenciaControl.updateValueAndValidity();
    });
  }

  habilitar() {
    return !this.formGroup.valid;
  }

  public emitirCFE(): void
  {
    const cfeDTO: CFEDTO = new CFEDTO();

    cfeDTO.eMail = this.keycloakService.getUsername();
    cfeDTO.adenda = this.adendaDTO;
    cfeDTO.identificacionCFE = this.identificacionCFEDTO;
    cfeDTO.emisorCFE = this.emisorCFEDTO;
    cfeDTO.receptorCFE = this.receptorCFEDTO;
    cfeDTO.totalesCFE = this.totalesCFEDTO;
    cfeDTO.detallesCFEs = this.detallesCFEsDTOs;
    cfeDTO.referenciasCFE = (this.mostrarReferencias && this.referenciasCFEDTO.tipoReferencia != 'NO_REFERENCIA') ? this.referenciasCFEDTO : null;

    this.progressSpinnerOverlayRef = this.progressOverlayService.open();

    this.emisionCfeService.emitirCFE(cfeDTO).subscribe(
      (respEmisionCFEDTO: RespuestaEmisionCFEDTO) =>
      {
        this.progressSpinnerOverlayRef.close();
        let mensajeInformacion: string = null;
        if (respEmisionCFEDTO !== null)
        {
          mensajeInformacion = 'Se ha emitido el comprobante fiscal electrónico (Serie: ' + respEmisionCFEDTO.serie + ', Número: ' + respEmisionCFEDTO.numero + ') exitosamente.';
          this.mensajeUtils.mostrarMensajeInformacion(mensajeInformacion, this.limpiar, null);
        }
      },
      (exception: any) =>
      {
        this. progressSpinnerOverlayRef.close();

        let descripcionTipoCFE: string = null;
        let descripcionTipoDocumentoReceptor: string = null;
        let mensajeError: string = null;

        switch (exception.error.appErrorCode)
        {
          case ERROR_FALTAN_DATOS_EN_DETALLES_CFE:
            mensajeError = `No pueden haber líneas de detalle sin referencia.`;
            break;
          case ERROR_DEL_SWITCH_AL_EMITIR_CFE:
            mensajeError = exception.error.message;
            break;
          case ERROR_GENERAL_AL_EMITIR_CFE:
            mensajeError = 'Se ha producido un error al emitir el comprobante fiscal electrónico.';
            break;
          case NO_EXISTE_REFERENCIA_EN_NOTA_DE_CREDITO:
          case NO_COINCIDE_RECEPTOR_EN_NOTA_DE_CREDITO:
            descripcionTipoCFE = cfeDTO.referenciasCFE.referenciaCFE.tipoCFE.descripcion;
            const serie: string = cfeDTO.referenciasCFE.referenciaCFE.serie;
            const numero: number = cfeDTO.referenciasCFE.referenciaCFE.numero;
            const fechaEmision: Date = cfeDTO.referenciasCFE.referenciaCFE.fechaEmision;
            descripcionTipoDocumentoReceptor = cfeDTO.receptorCFE.tipoDocumento.descripcion;
            const documentoReceptor: string = cfeDTO.receptorCFE.documento;
            const descripcionPaisReceptor: string = cfeDTO.receptorCFE.pais.descripcion;
            mensajeError = 'No existe el comprobante fiscal electrónico referenciado con los siguientes datos: \n\n' +
                           'Tipo CFE: ' + descripcionTipoCFE + '\n' +
                           'Serie: ' + serie + '\n' +
                           'Número: ' + numero + '\n' +
                           'Tipo documento receptor: ' + descripcionTipoDocumentoReceptor + '\n' +
                           'Documento receptor: ' + documentoReceptor + '\n' +
                           'País receptor: ' + descripcionPaisReceptor;
            break;
          case ERROR_COMBINACION_TIPO_CFE_Y_TIPO_DOCUMENTO_RECEPTOR_INVALIDO:
            descripcionTipoCFE = cfeDTO.identificacionCFE.tipoCFE.descripcion;
            descripcionTipoDocumentoReceptor = cfeDTO.receptorCFE.tipoDocumento.descripcion;
            mensajeError = 'No es posible emitir un comprobante fiscal electrónico con los siguientes datos: \n\n' +
                           'Tipo CFE: ' + descripcionTipoCFE + '\n' +
                           'Tipo documento receptor: ' + descripcionTipoDocumentoReceptor;
            break;
          default:
            mensajeError = 'Se ha producido un error al emitir el comprobante fiscal electrónico.';
            break;
        }

        this.mensajeUtils.mostrarMensajeError(mensajeError, null);
      },
      () =>
      {

      }
    );
  }

  private limpiarIdentificacion(): void
  {
    this.formGroup.get('tipoCFEControl').reset();
    this.formGroup.get('fechaEmisionControl').reset();
    this.formGroup.get('formaPagoControl').reset();
    this.formGroup.get('clausulaVentaControl').reset();
    this.formGroup.get('modalidadVentaControl').reset();
    this.formGroup.get('viaTransportacionControl').reset();

    this.identificacionCFEDTO.limpiar();

    this.datosInicioIdentificacionDTO.codigoTipoCFESeleccionado = null;
    this.datosInicioIdentificacionDTO.codigoFormaPagoSeleccionada = null;
  }

  private limpiarReceptor(): void
  {
    this.formGroup.get('tipoDocumentoReceptorControl').reset();
    this.formGroup.get('paisReceptorControl').reset();
    this.receptorComponent.limpiarAutocompletes();
    this.formGroup.get('direccionReceptorControl').reset();
    this.formGroup.get('ciudadReceptorControl').reset();
    this.formGroup.get('departamentoReceptorControl').reset();

    this.receptorCFEDTO.limpiar();

    this.datosInicioReceptorDTO.codigoTipoDocumentoSeleccionado = null;
    this.datosInicioReceptorDTO.codigoPaisSeleccionado = null;
    this.datosInicioReceptorDTO.esABM = false;
  }

  private limpiarDetalles(): void
  {
    this.detallesComponent.limpiar();
    // this.detallesCFEsDTOs.length = 0; ==> VERIFICAR SI ESTO ANDA (SERÍA LO IDEAL!!!)

    this.datosInicioDetallesDTO.esModoEResguardo = false;
    this.datosInicioDetallesDTO.indiceDetalleCFESeleccionado = null;
    this.datosInicioDetallesDTO.columnasMostradas = ['descripcion', 'cantidad', 'precioUnitario', 'precioVenta', 'impuesto', 'montoIVA', 'montoTotal', 'modificar', 'eliminar'];
    this.datosInicioDetallesDTO.sePuedeAgregarDetalleCFE = false;
  }

  private limpiarTotales(): void
  {
    this.formGroup.get('subtotalControl').reset();
    this.formGroup.get('montoIVAControl').reset();
    this.formGroup.get('montoTotalControl').reset();
    this.formGroup.get('montoTotalRetenidoEResgControl').reset();
    this.formGroup.get('montoTotalCreditoFiscalEResgControl').reset();
    this.formGroup.get('cantidadLineasDetallesControl').reset();

    this.totalesCFEDTO.limpiar();
    this.totalesCFEDTO.tipoMoneda = this.obtenerTipoMoneda('UYU');
    this.totalesCFEDTO.tipoCambio = 1;

    this.datosInicioTotalesDTO.esModoEResguardo = false;
    this.datosInicioTotalesDTO.codigoTipoMonedaSeleccionado = 'UYU';
    this.datosInicioTotalesDTO.estaHabilitadoTipoCambio = false;
  }

  private limpiarAdenda(): void
  {
    this.formGroup.get('adendaControl').reset();

    this.adendaDTO.texto = null;
  }

  private limpiarReferencias(): void
  {
    this.formGroup.get('tipoReferenciaControl').reset();
    this.formGroup.get('tipoCFEReferenciaControl').reset();
    this.formGroup.get('serieReferenciaControl').reset();
    this.formGroup.get('numeroReferenciaControl').reset();
    this.formGroup.get('fechaEmisionReferenciaControl').reset();
    this.formGroup.get('razonReferenciaControl').reset();

    this.referenciasCFEDTO.limpiar();
    this.referenciasCFEDTO.tipoReferencia = 'REF_ESPECIFICA';

    this.datosInicioReferenciasDTO.codigoTipoCFESeleccionado = null;
    this.datosInicioReferenciasDTO.mostrarReferenciaEspecifica = true;
  }

  public limpiar(): void
  {
    this.limpiarIdentificacion();
    this.limpiarReceptor();
    this.limpiarDetalles();
    this.limpiarTotales();
    this.limpiarAdenda();
    this.mostrarReferencias = false;
    this.limpiarReferencias();
    this.inicializarDatos();
  }

  public actualizarTotalesHandler($event: any)
  {
    if (Utils.isNotNullOrUndefined(this.identificacionCFEDTO.tipoCFE))
    {
      const codigoTipoCFE: number = this.identificacionCFEDTO.tipoCFE.codigo;

      if (codigoTipoCFE === COD_TIPO_CFE_E_RESGUARDO)
      {
        let detalleConReferencias = false;
        let sumaMontosTotalesRetenidos: number = 0;
        let sumaMontosTotalesCreditosFiscales: number = 0;

        for (const detalleCFEDTO of this.detallesCFEsDTOs)
        {
          const codigoCompuestoRetencion: string = detalleCFEDTO.tipoRetencionEResg.numeroForm.toString().padStart(4, '0') +
                                                   detalleCFEDTO.tipoRetencionEResg.cLinea.toString().padStart(3, '0');

          if (codigoCompuestoRetencion.startsWith(CREDITOS_FISCALES_COD_RET_PREFIX))
          {
            sumaMontosTotalesCreditosFiscales = +sumaMontosTotalesCreditosFiscales + +detalleCFEDTO.montoRetenidoEResg;
          }
          else
          {
            sumaMontosTotalesRetenidos = +sumaMontosTotalesRetenidos + +detalleCFEDTO.montoRetenidoEResg;
          }

          if (detalleCFEDTO.referenciaCFEEResg.serie != null && detalleCFEDTO.referenciaCFEEResg.numero != null && detalleCFEDTO.referenciaCFEEResg.fechaEmision ) {
            detalleConReferencias = true;
          }
        }

        const hayDetalles: boolean = (this.detallesCFEsDTOs.length !== 0);
        this.totalesCFEDTO.montoTotalRetenidoEResg = (hayDetalles) ? sumaMontosTotalesRetenidos : null;
        this.totalesCFEDTO.montoTotalCreditoFiscalEResg = (hayDetalles) ? sumaMontosTotalesCreditosFiscales : null;
        this.totalesCFEDTO.cantidadLineasDetalles = (hayDetalles) ? this.detallesCFEsDTOs.length : null;

        this.referenciasComponent.updateTabs(detalleConReferencias);
      }
      else
      {
        let sumaPreciosVentas: number = 0;
        let sumaMontosIVAsMinimos: number = 0;
        let sumaMontosIVAsBasicos: number = 0;
        let sumaMontosIVAsSuspensos: number = 0;
        let sumaMontosIVAs: number = 0;
        let sumaMontosTotales: number = 0;

        for (const detalleCFEDTO of this.detallesCFEsDTOs)
        {
          sumaPreciosVentas = +sumaPreciosVentas + +detalleCFEDTO.precioVenta;
          sumaMontosIVAs = +sumaMontosIVAs + +detalleCFEDTO.montoIVA;
          sumaMontosTotales = +sumaMontosTotales + +detalleCFEDTO.montoTotal;

          switch (detalleCFEDTO.impuesto.descripcion) {
            case 'IVA mínimo' : sumaMontosIVAsMinimos += detalleCFEDTO.montoIVA;
                                break;
            case 'IVA básico' : sumaMontosIVAsBasicos += detalleCFEDTO.montoIVA;
                                break;
            case 'IVA suspenso' : sumaMontosIVAsSuspensos += detalleCFEDTO.montoTotal;
                                  break;
          }
        }

        const hayDetalles: boolean = (this.detallesCFEsDTOs.length !== 0);
        this.totalesCFEDTO.subtotal = (hayDetalles) ? this.redondearHaciaAbajo(sumaPreciosVentas, 2) : null;
        this.totalesCFEDTO.montoIVAMinimo = (hayDetalles) ? this.redondearHaciaAbajo(sumaMontosIVAsMinimos, 2) : null;
        this.totalesCFEDTO.montoIVABasico = (hayDetalles) ? this.redondearHaciaAbajo(sumaMontosIVAsBasicos, 2) : null;
        this.totalesCFEDTO.montoIVASuspenso = (hayDetalles) ? this.redondearHaciaAbajo(sumaMontosIVAsSuspensos, 2) : null;
        this.totalesCFEDTO.montoIVA = (hayDetalles) ? this.redondearHaciaAbajo(sumaMontosIVAs, 2) : null;
        this.totalesCFEDTO.montoTotal = (hayDetalles) ? sumaMontosTotales : null;
        this.totalesCFEDTO.cantidadLineasDetalles = (hayDetalles) ? this.detallesCFEsDTOs.length : null;

        if (hayDetalles) {
          this.totalesComponent.updateMontoTotal();
        }
      }
    }
  }

  public cambioEnTipoCFEHandler(tipoCFEDTO: TipoCFEDTO): void
  {
    this.esEResguardo = tipoCFEDTO.codigo === COD_TIPO_CFE_E_RESGUARDO;
    this.codigoCFESeleccionado = tipoCFEDTO.codigo;
    this.setearIdentificacionCFEConditionalValidators(tipoCFEDTO.codigo);
    this.limpiarDetalles();
    this.limpiarTotales();
    this.limpiarReferencias();

    this.datosInicioReferenciasDTO.mostrarReferenciaEspecifica = !this.esEResguardo;

    this.actualizarEsModoEResguardo(tipoCFEDTO);
    this.actualizarMostrarReferencias(tipoCFEDTO);
    this.actualizarSePuedeAgregarDetalleCFE(tipoCFEDTO);
  }

  private actualizarEsModoEResguardo(tipoCFEDTO: TipoCFEDTO): void
  {
    if (Utils.isNotNullOrUndefined(tipoCFEDTO))
    {
      this.datosInicioDetallesDTO.esModoEResguardo = (tipoCFEDTO.codigo === COD_TIPO_CFE_E_RESGUARDO);
      this.datosInicioDetallesDTO.columnasMostradas = (this.datosInicioDetallesDTO.esModoEResguardo) ?
                                                        ['tipoRetencionEResg', 'tasaEResg', 'montoSujetoARetencionEResg', 'montoRetenidoEResg', 'tipoCFERefCFEEResg',
                                                        'serieRefCFEEResg', 'numeroRefCFEEResg', 'fechaEmisionRefCFEEResg', 'modificar', 'eliminar'] :
                                                        ['descripcion', 'cantidad', 'precioUnitario', 'precioVenta', 'impuesto', 'montoIVA',
                                                        'montoTotal', 'modificar', 'eliminar'];
      this.datosInicioTotalesDTO.esModoEResguardo = (tipoCFEDTO.codigo === COD_TIPO_CFE_E_RESGUARDO);
    }
  }

  private actualizarMostrarReferencias(tipoCFEDTO: TipoCFEDTO): void
  {
    if (Utils.isNotNullOrUndefined(tipoCFEDTO))
    {
      this.mostrarReferencias = this.esNotaDeCreditoElCodigoTipoCFE(tipoCFEDTO.codigo) || this.esNotaDeDebitoElCodigoTipoCFE(tipoCFEDTO.codigo) || this.esNotaDeDebitoExpElCodigoTipoCFE(tipoCFEDTO.codigo) || this.esNotaDeCreditoExpElCodigoTipoCFE(tipoCFEDTO.codigo) || this.esEResguardo;

      if (this.mostrarReferencias)
      {
        this.referenciasCFEDTO.referenciaCFE.tipoCFE = this.obtenerTipoCFEAnulado(tipoCFEDTO);
        this.datosInicioReferenciasDTO.codigoTipoCFESeleccionado = this.referenciasCFEDTO.referenciaCFE.tipoCFE.codigo;
      }
    }
  }

  private actualizarSePuedeAgregarDetalleCFE(tipoCFEDTO: TipoCFEDTO): void
  {
    this.datosInicioDetallesDTO.sePuedeAgregarDetalleCFE = Utils.isNotNullOrUndefined(tipoCFEDTO);
  }

  private esNotaDeCreditoElCodigoTipoCFE(codigoTipoCFE: number): boolean
  {
    return (codigoTipoCFE === COD_TIPO_CFE_NOTA_CREDITO_E_FACTURA || codigoTipoCFE === COD_TIPO_CFE_NOTA_CREDITO_E_TICKET);
  }

  private esNotaDeDebitoElCodigoTipoCFE(codigoTipoCFE: number): boolean
  {
    return (codigoTipoCFE === COD_TIPO_CFE_NOTA_DEBITO_E_FACTURA || codigoTipoCFE === COD_TIPO_CFE_NOTA_DEBITO_E_TICKET);
  }

  private esNotaDeDebitoExpElCodigoTipoCFE(codigoTipoCFE: number): boolean
  {
    return (codigoTipoCFE === COD_TIPO_CFE_NOTA_DEBITO_E_FACTURA_EXP);
  }

  private esNotaDeCreditoExpElCodigoTipoCFE(codigoTipoCFE: number): boolean
  {
    return (codigoTipoCFE === COD_TIPO_CFE_NOTA_CREDITO_E_FACTURA_EXP);
  }

  private obtenerTipoCFEAnulado(tipoCFEDTO: TipoCFEDTO): TipoCFEDTO
  {
    let codigoTipoCFEAnulado: number = null;

    switch (tipoCFEDTO.codigo)
    {
      case COD_TIPO_CFE_NOTA_CREDITO_E_FACTURA:
        codigoTipoCFEAnulado = COD_TIPO_CFE_E_FACTURA;
        break;
      case COD_TIPO_CFE_NOTA_CREDITO_E_TICKET:
        codigoTipoCFEAnulado = COD_TIPO_CFE_E_TICKET;
        break;
      case COD_TIPO_CFE_NOTA_DEBITO_E_FACTURA:
        codigoTipoCFEAnulado = COD_TIPO_CFE_NOTA_CREDITO_E_FACTURA;
        break;
      case COD_TIPO_CFE_NOTA_DEBITO_E_TICKET:
        codigoTipoCFEAnulado = COD_TIPO_CFE_NOTA_CREDITO_E_TICKET;
        break;
      case COD_TIPO_CFE_NOTA_CREDITO_E_FACTURA_EXP:
        codigoTipoCFEAnulado = COD_TIPO_CFE_E_FACTURA_EXP;
        break;
      case COD_TIPO_CFE_NOTA_DEBITO_E_FACTURA_EXP:
        codigoTipoCFEAnulado = COD_TIPO_CFE_NOTA_CREDITO_E_FACTURA_EXP;
        break;
      case COD_TIPO_CFE_E_RESGUARDO:
        codigoTipoCFEAnulado = COD_TIPO_CFE_E_RESGUARDO;
        break;
      default:
        codigoTipoCFEAnulado = null;
    }

    const tipoCFEAnuladoDTO: TipoCFEDTO = this.obtenerTipoCFE(codigoTipoCFEAnulado);

    return tipoCFEAnuladoDTO;
  }

  private obtenerTipoCFE(codigoTipoCFE: number): TipoCFEDTO
  {
    let tipoCFEARetornarDTO: TipoCFEDTO = null;

    for (const tipoCFEDTO of this.datosInicioReferenciasDTO.tiposCFEsDTOs)
    {
      if (tipoCFEDTO.codigo === codigoTipoCFE)
      {
        tipoCFEARetornarDTO = tipoCFEDTO;
        break;
      }
    }

    return tipoCFEARetornarDTO;
  }

  private obtenerTipoMoneda(codigoTipoMoneda: string): TipoMonedaDTO
  {
    let tipoMonedaARetornarDTO: TipoMonedaDTO = null;
    for (const tipoMonedaDTO of this.datosInicioTotalesDTO.tiposMonedasDTOs)
    {
      if (tipoMonedaDTO.codigo === codigoTipoMoneda)
      {
        tipoMonedaARetornarDTO = tipoMonedaDTO;
        break;
      }
    }

    return tipoMonedaARetornarDTO;
  }

  redondearHaciaAbajo(number: number, decimalPlaces: number): number {
    const factor = Math.pow(10, decimalPlaces);
    const roundedNum = Math.round(number * factor) / factor;
    const truncatedNum = Math.trunc(number * factor) / factor;
    const truncatedIntegerValue = Math.trunc(number * factor);
    const referenceValue = number * factor - truncatedIntegerValue;

    if (referenceValue <= 0.5) {
      return truncatedNum;
    } else {
      return roundedNum;
    }
  }
}
